export const state = {
  isLoading: false,
  isPrepaid: false
};

export const getters = {
  isLoading: (state) => state.isLoading,
  isPrepaid: (state) => state.isPrepaid,
};

export const mutations = {
  setLoading(state, newValue) {
    state.isLoading = newValue;
  },
  setPrepaid(state, newValue) {
    state.isPrepaid = newValue;
  },
};

export const actions = {
  setLoading({ commit }, newValue) {
    commit("setLoading", newValue);
  },
  setPrepaid({ commit }, newValue) {
    commit("setPrepaid", newValue);
  },
};
